"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = isDevEnv;

function isDevEnv() {
  return !process.env.NODE_ENV || process.env.NODE_ENV === "development";
}
//# sourceMappingURL=isDevEnv.js.map